import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import toast from 'react-hot-toast';
import Navbar from '../Navbar/Navbar';
import Footer from '../Footer/Footer';

function EditPodcast() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [podcast, setPodcast] = useState({
        title: '',
        description: '',
        image_url: '',
        isDefault: false
    });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchPodcast = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_URL}/podcast/${id}`);
                setPodcast({
                    title: response.data.title || '',
                    description: response.data.description || '',
                    image_url: response.data.image_url || '',
                    isDefault: response.data.isDefault || false
                });
            } catch (error) {
                console.error("Error fetching podcast:", error);
                toast.error("خطا در دریافت اطلاعات پادکست");
            } finally {
                setLoading(false);
            }
        };
        fetchPodcast();
    }, [id]);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setPodcast({
            ...podcast,
            [name]: type === 'checkbox' ? checked : value
        });
    };

    const handleUpdate = async (e) => {
        e.preventDefault();
        try {
            const response = await axios.put(`${process.env.REACT_APP_API_URL}/podcast/${id}`, podcast);
            if (response.data.success) {
                toast.success("پادکست با موفقیت ویرایش شد!");
                navigate('/podcast');
            } else {
                toast.error(response.data.message);
            }
        } catch (error) {
            console.error("Update error:", error);
            toast.error("خطا در ویرایش پادکست");
        }
    };

    if (loading) {
        return (
            <>
                <Navbar />
                <div className="container mt-5">
                    <div className="text-center py-5">
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                        <p className="mt-3">در حال بارگذاری...</p>
                    </div>
                </div>
                <Footer />
            </>
        );
    }

    return (
        <>
            <Navbar />
            <div className="container mt-5 mb-5">
                <div className="row justify-content-center">
                    <div className="col-md-8">
                        <div className="card shadow">
                            <div className="card-header bg-warning">
                                <h3 className="mb-0">✏️ ویرایش پادکست</h3>
                            </div>
                            <div className="card-body">
                                <form onSubmit={handleUpdate}>
                                    <div className="mb-3">
                                        <label className="form-label">عنوان *</label>
                                        <input 
                                            type="text" 
                                            className="form-control" 
                                            name="title" 
                                            value={podcast.title} 
                                            onChange={handleChange} 
                                            required 
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">توضیحات</label>
                                        <textarea 
                                            className="form-control" 
                                            name="description" 
                                            value={podcast.description} 
                                            onChange={handleChange} 
                                            rows="3"
                                            placeholder="توضیحات پادکست..."
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">آدرس تصویر</label>
                                        <input 
                                            type="text" 
                                            className="form-control" 
                                            name="image_url" 
                                            value={podcast.image_url} 
                                            onChange={handleChange} 
                                            placeholder="https://example.com/podcast-cover.jpg" 
                                        />
                                    </div>

                                    <div className="mb-3 form-check">
                                        <input 
                                            type="checkbox" 
                                            className="form-check-input" 
                                            id="isDefault" 
                                            name="isDefault" 
                                            checked={podcast.isDefault} 
                                            onChange={handleChange} 
                                        />
                                        <label className="form-check-label" htmlFor="isDefault">
                                            پادکست پیش‌فرض (در صفحه اصلی نمایش داده می‌شود)
                                        </label>
                                    </div>

                                    <div className="d-flex justify-content-between">
                                        <button type="submit" className="btn btn-warning">💾 ذخیره تغییرات</button>
                                        <button type="button" className="btn btn-secondary" onClick={() => navigate('/podcast')}>انصراف</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
}

export default EditPodcast;